import { MoonIcon, SunIcon } from '@wolfejs/icons/IconMap';
import type { ButtonProps } from '../Button/Button';
import { Button } from '../Button/Button';
import { UISizes, UIVariants } from '../types/UI';
import { cn } from '../utils/classnames';

export type ThemeModeToggleProps = ButtonProps & {
  themeMode?: string;
};

export const ThemeModeToggle = ({ themeMode, ...otherProps }: ThemeModeToggleProps) => {
  return (
    <Button variant={UIVariants.ghost} {...otherProps} className="relative" size={UISizes.xs}>
      <MoonIcon className={cn({ hidden: themeMode !== 'light' })} />
      <SunIcon className={cn({ hidden: themeMode !== 'dark' })} />
    </Button>
  );
};
